module.exports = __webpack_public_path__ + "static/restrictions-307902b64532ad7691d023b48691b244.svg";